module.exports = __webpack_public_path__ + "media/images/avatar/18-e025b778ac5dbabef5a58dcec4417950.svg";